<template>
  <div>
    <div class="container">
      <div class="detailSwiper">
        <mt-swipe :auto="0">
          <template v-if="productInfo.ProductItemImgs && productInfo.ProductItemImgs.length > 0">
            <mt-swipe-item v-for="(item, index) in productInfo.ProductItemImgs" :key="index">
              <van-image :src="item.Url" fit="cover" lazy-load class="swiperPic none-select" />
            </mt-swipe-item>
          </template>
          <template v-if="productInfo.ProductItemImgs && productInfo.ProductItemImgs.length === 0">
            <mt-swipe-item>
              <van-image :src="productInfo.ShowPicUrl" fit="cover" lazy-load class="swiperPic" />
            </mt-swipe-item>
          </template>
        </mt-swipe>
      </div>
      <div class="detail-tab">
        <!-- 价格 / 免单卡数 -->
        <div class="detail-tab-top">
          <div class="title-left">
            <span class="title-short">{{ productInfo.TitleShort }}</span>
            <div class="title-price">
              <div class="price-tag">
                {{ productInfo.IsFreeCard ? (productInfo.IsNewPerson ? '新人专享' : '免单卡') : '到手价' }}
              </div>
              <template v-if="productInfo.IsFreeCard">
                <!-- 新人 -->
                <template v-if="productInfo.IsNewPerson">
                  <div class="price-discount-int">1</div>
                  <div class="price-discount-decimal fs-26">张</div>
                  <div class="price-card-through t_999">免单卡{{ productInfo.FreeCardNum }}张</div>
                </template>
                <!-- 不是新人 -->
                <template v-else>
                  <div class="price-discount-int">
                    {{ productInfo.FreeCardNum }}
                  </div>
                  <div class="price-discount-decimal fs-26">张</div>
                </template>
              </template>
              <template v-else>
                <div class="price-char">￥</div>
                <div class="price-discount-int">
                  {{ productInfo.SaleDiscountPrice | toFixedInt }}
                </div>
                <div class="price-discount-decimal fs-13">.{{ productInfo.SaleDiscountPrice | toFixedDecimal }}</div>
                <span class="price-discount-through">￥{{ productInfo.ProductPrice | toFixed }}</span>
              </template>
            </div>
          </div>
        </div>
        <!-- 说明 -->
        <div class="detail-tab-bottom" @click="slideToggle()">
          <div class="detail-allow-right" :class="[detailSlideOpen ? 'rotate-45' : '']"></div>
          <div class="detail-tab-bottom" v-show="detailSlideOpen">
            <div class="detail-tab-slide">
              <span class="rebate-tag">垫付</span>
              <span class="rebate-span">￥{{ productInfo.ProductPrice | toFixed }} 在{{ PLATFORM_TYPE_DETAIL[platformType].collectively }}App以原价购买商品</span>
            </div>
          </div>
          <div class="detail-tab-slide">
            <span class="rebate-tag">返利</span>
            <span class="rebate-span" v-if="productInfo.IsFreeCard">￥{{ productInfo.ProductPrice | toFixed }} 收货后即可获得全额返利</span>
            <span class="rebate-span" v-else>￥{{ (productInfo.ProductPrice - productInfo.SaleDiscountPrice) | toFixed }} 收货后即可获得返利</span>
          </div>
          <!-- 风险提示 -->
          <div class="detail-tab-risk" v-show="detailSlideOpen">
            <div class="rist-tip"><i class="iconfont icon-tubiaozhizuomoban"></i> 垫付零风险</div>
            <div class="rist-detail" @click.stop="riskDialogShow = true">查看详情<i class="iconfont icon-xiangzuo1"></i></div>
          </div>
        </div>
      </div>
      <!-- 说明模块 -->
      <instructions-for-use :is-rebate-open="productInfo.IsNewPerson" :product-info="productInfo" :platform-type="platformType"> </instructions-for-use>
      <!-- echarts -->
      <div class="echarts-box" v-if="orderFreeCardList && orderFreeCardList.length > 0">
        <div class="echart-title">
          <span @click="echartsReason">变化原因？</span>
        </div>
        <div class="echarts-box">
          <div id="echarts-line"></div>
        </div>
      </div>
      <!-- 成功兑换用户 -->
      <success-convert-slide :product-info="productInfo" :scoll-user-list="scollUserList"> </success-convert-slide>
      <!-- 抢购时间 -->
      <!-- 不显示抢购时间节点，有库存和没有抢购节点则隐藏模块 -->
      <panic-buy-time-node v-if="productInfo.IsScareBuyTime && !(haveStock && !productInfo.ScareBuyNodeList)" :nodeList="productInfo.ScareBuyNodeList"> </panic-buy-time-node>
      <!-- 图片详情 -->
      <div class="pro-detail">
        <div class="p-titel">
          <span>商品详情</span>
          <span class="t_999">DETAILS</span>
        </div>
        <div class="pro-contain" v-if="imgDetailSrc.length > 0">
          <img v-for="(item, index) in imgDetailSrc" :key="index" v-lazy="item" />
        </div>
      </div>
      <segement-Line v-if="imgDetailSrc.length > 0" line-text="已经到底了"> </segement-Line>
      <segement-Line v-else line-text="暂无图片"> </segement-Line>
      <!-- 底部 -->
      <div class="pro-detail-btn flex">
        <div class="leftPart">
          <div class="secondaryBtn tapActive" @click="$router.push({ name: 'souhuo' })">
            <div class="con">
              <span class="iconfont icon-shouye1"></span>
              <span class="label">首页</span>
            </div>
          </div>
          <div class="secondaryBtn tapActive" @click="contactCs">
            <div class="con">
              <span class="iconfont icon-kefu2"></span>
              <span class="label">客服</span>
            </div>
          </div>
          <div class="secondaryBtn tapActive" @click="collectionBtn">
            <div class="con">
              <span class="iconfont icon-shoucang1" :class="productInfo.IsFavorite ? 'icon-shoucang2 active' : 'icon-shoucang1'"></span>
              <span class="label">{{ productInfo.IsFavorite ? '已收藏' : '收藏' }}</span>
            </div>
          </div>
        </div>

        <div class="rightPart">
          <div class="mainBtn tapActive" @click="shareClick">分享商品</div>
          <template v-if="iSOnTheShelf && haveStock">
            <div class="mainBtn tapActive" v-if="productInfo.IsFreeCard" @click="handleConvert">立即兑换</div>
            <div class="mainBtn tapActive" v-else @click="openSouhuo">立即购买</div>
          </template>
          <template v-else>
            <div class="mainBtn chackTime tapActive" @click="showGoodsTime">
              <template v-if="!getIsShowRemindBtn">
                <div class="subCon">
                  <span>查看</span>
                  <span>抢购时间</span>
                </div>
              </template>
              <template v-else>
                <div class="subCon">
                  <span>{{ isPrePurchase ? '已预约' : '预约' }}</span>
                  <span>抢购提醒</span>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
      <!-- ******************* 内容 end ******************* -->
      <!-- 模态框 -->
      <modal-pupop
        ref="modalframe"
        :is-show-modal="isShowModal"
        :is-no-product="isNoProduct"
        :product-info="productInfo"
        :is-buy-remind="isCancelRemid"
        @addToRemindClip="addToRemindClip"
        @closeSouhuo="isShowModal = false"
      >
      </modal-pupop>
      <black-list-dialog v-if="blackListDialogShow" :limit-count="dialogLimitCount" @close="blackListDialogShow = false"> </black-list-dialog>
      <!-- 垫付保障弹窗 -->
      <risk-dialog v-if="riskDialogShow" :platform-type="platformType" @close="riskDialogShow = false"> </risk-dialog>
      <!-- 抢购时间节点弹窗 web-->
      <time-node-dialog
        v-if="nodeTimeDialogShow"
        :node-data="productInfo.ScareBuyNodeList"
        :only-show-time="true"
        :show-cancel-btn="false"
        show-type="timeNode"
        tip="商品会在下列时间节点补货，建议添加收藏，方便到点快速抢购~"
        sure-btn-text="我知道了"
        @onConfirm="nodeTimeDialogShow = false"
      >
      </time-node-dialog>
      <!-- 抢购时间节点弹窗 app-->
      <time-node-dialog
        v-if="isShowTimeNodeDialogOfApp"
        :node-data="currentNodeData"
        show-type="timeNode"
        tip="商品会在下列时间节点补货，请选择想收到抢购提醒的时间："
        sure-btn-text="确认设置"
        @onConfirm="timeNodeDialogConfirmHandler"
        @onCancel="isShowTimeNodeDialogOfApp = false"
      ></time-node-dialog>
      <!-- 变化原因图片 -->
      <preview-dialog v-if="previewDialogShow" mask-opacity="0.8" :img-src="previewImgSrc" @close="closeEcharsImg"> </preview-dialog>
      <!-- 返回顶部 -->
      <quick-top @returnTop="returnTop" :isReturn="isReturn" :position-btm="120"></quick-top>
      <!-- ShareSheet 分享面板组件 -->
      <share-popup :sharePopupData="sharePopupData" @onSelect="onShareTypeSelect"></share-popup>
    </div>
    <!-- 单月免单订单超额弹出窗 -->
    <van-dialog
      v-model="isShowWarnOfLimitDialog"
      show-cancel-button
      confirmButtonColor="#0077ff"
      :confirmButtonText="warnOfLimitDialogInfo.confirmButtonText"
      :cancelButtonText="warnOfLimitDialogInfo.cancelButtonText"
      @confirm="warnOfLimitDialogConfirm"
      @cancel="warnOfLimitDialogCancel"
    >
      <div class="warnOfLimitDialogContent">
        <div class="title">提示</div>
        <div class="tip item">{{ warnOfLimitDialogInfo.title }}</div>
        <div class="item mainItem">
          <div class="dot" :class="{ alert: warnOfLimitDialogInfo.exceedLimit }"></div>
          <div class="label">已兑换：{{ warnOfLimitDialogInfo.mainContent['已兑换数量'] }}件</div>
          <van-tag type="primary" plain color="#f22c2c" v-if="warnOfLimitDialogInfo.exceedLimit">已达上限</van-tag>
        </div>
        <div class="item mainItem">
          <div class="dot normal"></div>
          <div class="label">上限：{{ warnOfLimitDialogInfo.mainContent['单月兑换上限'] }}件</div>
        </div>
        <div class="subTip item" v-text="warnOfLimitDialogInfo.subTip"></div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Tag } from 'vant'
import { mapGetters, mapMutations } from 'vuex'
import { IMG_BASE_URL } from '@/config'
import SegementLine from '@/components/puppetComponent/SegementLine'
import RiskDialog from '@/components/puppetComponent/RiskDialog'
import ModalPupop from '@/components/smartComponent/ModalPupop'
import QuickTop from '@/components/smartComponent/QuickTop'
import TimeNodeDialog from '@/components/smartComponent/TimeNodeDialog'
import BlackListDialog from './children/BlackListDialog'
import InstructionsForUse from './children/InstructionsForUse'
import SuccessConvertSlide from './children/SuccessConvertSlide'
import PanicBuyTimeNode from './children/PanicBuyTimeNode'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import moment from 'moment'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import SharePopup from '@/components/smartComponent/SharePopup'
import { GetShareGoodsImage, RecommendProductFrontEndConvertLink } from '@/api/share'
import { SaleProductInfo, SoHo, CheckIsExistSOrder } from '@/api/detailPage'
import { ProductFavoriteAdd, IsSetRemind } from '@/api/remind'
import Utils from '@/utils/base'
import { removeStore } from '@/utils/session'
import setRemind from '@/mixins/setRemind'
import { LIMIT_TYPE } from '@/constants/index.js'

const echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/title')
require('echarts/lib/component/tooltip')

export default {
  mixins: [setRemind],
  data() {
    return {
      finishedLoading: false,
      productID: '',
      productInfo: {},
      // rebateOpen: true, // 购买说明模块是否展开
      scollUserList: [],
      // isAuditing: true,
      detailSlideOpen: false,
      blackListDialogShow: false,
      riskDialogShow: false,
      nodeTimeDialogShow: false,
      dialogLimitCount: 0,
      // 是否有库存
      haveStock: true,
      // 是否上架
      iSOnTheShelf: true,
      isCancelRemid: false,
      // 提醒设置点击控制
      isSetting: false,
      // 图片img
      imgDetailSrc: [],
      isNoProduct: false,
      isShowModal: false,
      countInterval: null,
      mimutes: 0,
      container: null,
      isReturn: false,
      isBaseSaleModel: false, // 是否为基础销量模式
      orderFreeCardList: [], // 最近10笔免单卡变化数据
      // 是否从0元区进入
      isFreeCard: undefined,
      // 上一个页面路由
      beforeRouteName: '',
      previewDialogShow: false,
      // /upaiyun/Sys/20191031/4716690707447509207.jpg'
      previewImgSrc: IMG_BASE_URL + '/upaiyun/Sys/20191031/5634353368715796548.jpg',
      echartsElem: null,
      curDataIndex: 0,
      platformType: 0, // 1:拼多多,2京东
      IsCfmdLimitArea: false, // 是否已经二次确认了疫情区域
      sharePopupData: {
        isShow: false,
        posterPic: ''
      },
      isFreeCardLimitRemind: false, // 是否已经二次确认了免单订单上限提醒
      isShowWarnOfLimitDialog: false, // 是否展示单月免单订单超额弹出窗
      warnOfLimitDialogInfo: {
        exceedLimit: false, // 是否已达上限
        mainContent: {}, // 主要内容
        subTip: '', // 提示
        confirmButtonText: '继续兑换',
        cancelButtonText: '取消'
      }
    }
  },
  components: {
    SegementLine,
    ModalPupop,
    QuickTop,
    BlackListDialog,
    InstructionsForUse,
    SuccessConvertSlide,
    PanicBuyTimeNode,
    RiskDialog,
    TimeNodeDialog,
    PreviewDialog,
    SharePopup,
    'van-tag': Tag
  },
  beforeCreate() {
    MessageBox.close()
  },
  mounted() {
    this.productID = this.$route.query.productID
    if (!this.productID) {
      setTimeout(() => {
        Toast('该信息不存在！')
        this.$router.go(-1)
      }, 1000)
      return
    }
    this.fetchData()
    // 绑定监听事件
    this.$nextTick(() => {
      this.container = document.getElementsByClassName('container')[0]
      this.container.addEventListener('scroll', this.handleScroll)
    })
    // app登录之后，刷新页面
    this.$EventBus.$on('app_refreshFlag', () => {
      this.fetchData()
    })
  },
  computed: {
    ...mapGetters(['loginState', 'getIsApp', 'getIsAuthorized', 'getIsShowRemindBtn', 'getIfShowAppDownloadGuide']),
    isPrePurchase() {
      let isPrePurchase = false

      if (!this.productInfo.ScareBuyNodeList) return isPrePurchase

      this.productInfo.ScareBuyNodeList.forEach(function(val) {
        if (val.IsPrePurchase === true) {
          isPrePurchase = true
        }
      })

      return isPrePurchase
    }
  },
  methods: {
    ...mapMutations([
      'SET_SOHO_INFO',
      'AUTHORIZE_POPUP_SHOW',
      'SET_ACCURATE_MODE',
      'SET_CONFIG_ACCURATE_MODE',
      'SET_CUR_PLATFORM_TYPE',
      'SET_IF_SHOW_APP_DOWNLOAD_GUIDE',
      'SET_IF_SHOW_APP_RESERVE_REMIND',
      'SET_GUIDE_TO_APP_POPUP_INFO'
    ]),
    timeNodeDialogConfirmHandler(remindTimeOriginal) {
      const { ProductID, ScareBuyNodeList } = this.productInfo
      this.timeNodeHandler({ productId: ProductID, remindTimeOriginal, timeOriginal: ScareBuyNodeList })
    },
    setRemindResSucessHandler() {
      this.productInfo.ScareBuyNodeList.forEach((ScareBuyNodeListVal) => {
        if (
          this.remindTimeOriginal.findIndex((remindTimeOriginal) => {
            return JSON.stringify(remindTimeOriginal) === JSON.stringify(ScareBuyNodeListVal)
          }) > -1
        ) {
          ScareBuyNodeListVal.IsPrePurchase = true
        } else {
          ScareBuyNodeListVal.IsPrePurchase = false
        }
      })
      this.isShowTimeNodeDialogOfApp = false
    },
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.finishedLoading = false
      if (this.$route.query.isFreeCard === 'true' || this.$route.query.isFreeCard === true) {
        this.isFreeCard = true
      } else if (this.$route.query.isFreeCard === 'false' || this.$route.query.isFreeCard === false) {
        this.isFreeCard = false
      } else {
        this.isFreeCard = undefined
      }
      let params = { productID: this.productID }
      SaleProductInfo(params)
        .then((res) => {
          Indicator.close()
          const { IfShowAppDownloadGuide, IfShowAppReserveRemind, SaleProductInfo } = res
          this.SET_IF_SHOW_APP_DOWNLOAD_GUIDE(IfShowAppDownloadGuide)
          this.SET_IF_SHOW_APP_RESERVE_REMIND(IfShowAppReserveRemind)
          let ShowPicUrl = {
            ItemImgID: null,
            Url: SaleProductInfo.ShowPicUrl,
            Position: null
          }
          let productInfo = SaleProductInfo
          productInfo.ProductItemImgs[0] = ShowPicUrl
          this.productInfo = productInfo
          this.finishedLoading = true
          // 分享
          let shareLink = `goodsDetail,productID,${this.productID},isFreeCard,${this.$route.query.isFreeCard}`
          Utils.shareApi(this.productInfo.TitleShort, this.productInfo.ShowPicUrl, shareLink)
          // if (this.productInfo.IsExistFinishedTask) {
          //   this.rebateOpen = false
          //   this.detailSlideOpen = false
          // } else {
          //   this.rebateOpen = true
          //   this.detailSlideOpen = true
          // }
          // // * IsAuditing
          // // * IsAuditing2
          // // 控制小程序 审核展现
          // this.isAuditing = false
          this.haveStock = this.productInfo.IsStockNoZero
          this.iSOnTheShelf = this.productInfo.IsSale
          this.isCancelRemid = this.productInfo.IsFavorite
          // 拼多多
          if (this.productInfo.ShopType === 2) {
            this.imgDetailSrc = this.productInfo.PddProductDetailList || []
          } else {
            this.imgDetailSrc = this.setDetailImg(this.productInfo.DescText)
          }
          // this.platformType = this.productInfo.ShopType === 2 ? 1 : 0;
          this.platformType = this.$utils.shopTypeNumChangeToPlatformType(this.productInfo.ShopType)
          this.orderFreeCardList = this.productInfo.OrderFreeCardList
          this.scollUserList = [...this.productInfo.BuyUserList, ...this.productInfo.BuyUserList.slice(0, 2)]
          // 垫付返利模块展现的折叠使用是否为新人判断
          this.detailSlideOpen = this.productInfo.IsNewPerson
          Utils.setNewcomerStorage(this.productInfo.IsNewPerson)
          // 从0元区进入 当前商品变为不免单
          if (this.isFreeCard && !this.productInfo.IsFreeCard) {
            MessageBox({
              title: '提示',
              message: '商品免单活动结束啦，下次快点抢吧~',
              showCancelButton: false,
              confirmButtonText: '我知道了',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') {
                this.$router.replace({
                  name: 'zeroBuyMain'
                })
              }
            })
          }
          // 从非0元区进入 当商品变为免单
          if (this.isFreeCard !== undefined && !this.isFreeCard && this.productInfo.IsFreeCard) {
            this.changeToFreeCard('商品已加入免单活动，需要免单卡才能进行兑换，是否继续购买？', true)
          }
          this.$nextTick(() => {
            this.echartsLineInit()
          })
        })
        .catch((res) => {
          Indicator.close()
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
        })
    },
    // 正则抽取img标签src图片
    setDetailImg(htmlData) {
      if (!htmlData) return []
      // 最终图片集
      let picUrl = []
      // 特定匹配集
      let picUrlGiven = []
      // 除特定匹配集的匹配集
      let picUrlAll = []
      let regexpAll = /<img.*?(?:>|\/>)/gi
      let regexpOne = /<img[^(align="absmiddle")]+?src="([^"]*)">/gi
      let regexpTwo = /<img src="([^"]*)">/gi
      let regexpThree = /<img src="([^"]*)"[^>]+>/gi
      let regexpSrc = /<img.+?src="([^"]*)"([^>]*)?>/gi
      let allSrcs = []
      // 截取img标签及内容
      if (htmlData.match(regexpAll)) {
        allSrcs = htmlData.match(regexpAll)
      }
      // 遍历获取url
      if (allSrcs.length > 0) {
        allSrcs.forEach((item) => {
          if (regexpOne.test(item)) {
            picUrlGiven.push(item.replace(regexpOne, '$1'))
          } else if (regexpTwo.test(item)) {
            picUrlGiven.push(item.replace(regexpTwo, '$1'))
          } else if (regexpThree.test(item)) {
            picUrlGiven.push(item.replace(regexpThree, '$1'))
          } else {
            let imgUrl = item.replace(regexpSrc, '$1')
            if (imgUrl.indexOf('?') !== -1) {
              // 排除【.png?xxx】格式的图片，此类型图片加载不出
              imgUrl = imgUrl.split('?')[0]
              if (!/\.png$/gi.test(imgUrl)) {
                picUrlAll.push(imgUrl)
              }
            } else {
              // 排除【.gif】结尾图片，此类型图片加载不出
              if (this.checkImgSrcUrl(imgUrl)) {
                picUrlAll.push(imgUrl)
              }
            }
          }
        })
        // 如有匹配到[特定匹配格式(regexpOne，regexpTwo)]的图片优先使用
        if (picUrlGiven.length > 1) {
          picUrl = picUrlGiven
        } else {
          picUrl = picUrlAll
        }
      }
      return picUrl
    },
    // 正则校验图片格式
    checkImgSrcUrl(url) {
      return /^(http|https):\/\/.+\.(jpg|png|jpeg)$/gi.test(url)
    },
    // 说明切换
    slideToggle() {
      this.detailSlideOpen = !this.detailSlideOpen
    },
    formatCountDownTime(time) {
      if (!time) return ''
      time = time * 1000
      if (time >= 1000 * 60 * 60) {
        return moment(time).format('HH:mm:ss')
      } else if (time >= 1000 * 60) {
        return moment(time).format('mm:ss')
      } else {
        return time / 1000
      }
    },
    // echart显示
    echartsLineInit() {
      if (!this.orderFreeCardList || this.orderFreeCardList.length <= 0) return
      let yData = []
      this.orderFreeCardList.forEach((item, index) => {
        yData.push(index + 1 + '')
      })
      this.orderFreeCardList.reverse()
      let _this = this
      let option = {
        title: {
          left: 'center',
          top: '15',
          text: `近${this.orderFreeCardList.length}笔交易免单卡变化图`,
          textStyle: {
            fontWeight: 500,
            fontSize: 15
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            _this.curDataIndex = params[0].dataIndex
            return params[0].data + '张免单卡'
          }
        },
        xAxis: {
          show: false,
          type: 'category',
          data: yData,
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: '免\n单\n卡\n数',
          nameLocation: 'middle',
          nameRotate: 0,
          nameTextStyle: {
            lineHeight: 16,
            padding: [0, 5, 0, 0]
          },
          offset: -5,
          minInterval: 1,
          axisLabel: {
            color: '#999999'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: '交易图',
            data: this.orderFreeCardList,
            type: 'line',
            symbolSize: 4,
            smooth: true,
            lineStyle: {
              color: '#fe7f43',
              width: 2
            }
          }
        ]
      }
      // 数组项都为1时，y轴最大值为2
      let firstVal = this.orderFreeCardList[0]
      let allIsEquals = this.orderFreeCardList.every((val) => {
        return val === firstVal
      })
      if (allIsEquals && firstVal <= 1) option.yAxis.max = firstVal + 1
      // 初始化echarts
      let chartElem = (this.echartsElem = echarts.init(document.getElementById('echarts-line'), { height: 100 }))
      chartElem.setOption(option)
      chartElem.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: this.orderFreeCardList.length - 1
      })
    },
    echartsReason() {
      this.previewDialogShow = true
      if (this.echartsReason) this.echartsElem.dispatchAction({ type: 'hideTip' })
    },
    closeEcharsImg() {
      this.previewDialogShow = false
      if (!this.echartsReason) return
      this.echartsElem.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: this.curDataIndex || 0
      })
    },
    unLoginModal() {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    },
    // 立即收货数据获取
    fetchOpenShouhuoData(productID) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        productID: productID,
        isFreeCard: this.productInfo.IsFreeCard,
        isFirst: true,
        IsCfmdLimitArea: this.IsCfmdLimitArea,
        isFreeCardLimitRemind: this.isFreeCardLimitRemind
      }
      SoHo(params)
        .then((res) => {
          Indicator.close()
          if (res.Data) {
            // 在黑名单的用户，读取限制期限、天数的信息
            this.blackListDialogShow = true
            if (res.Data.IsLongDay || res.Data.LastDay <= 0) {
              this.dialogLimitCount = 0
            } else {
              this.dialogLimitCount = res.Data.LastDay
            }
          } else {
            // 关键词精确模式开关配置、关键词精确模式
            this.SET_ACCURATE_MODE(res.AccurateMode)
            this.SET_CONFIG_ACCURATE_MODE(res.ConfigAccurateMode)
            // 无黑名单异常
            this.SET_SOHO_INFO(res.SoHoInfo)
            // 如果是新订单，不能进入CheckIsExistSOrder接口的，基础销量模式判断
            this.isBaseSaleModel = res.SoHoInfo.IsBaseSaleModel
            if (this.isBaseSaleModel) {
              // 基础销量模式(京东不存在基础销量模式)
              let toRouteName = 'baseStepOne'
              let queryData = {
                productId: this.productInfo.ProductID,
                isFreeCard: this.productInfo.IsFreeCard
              }
              if (this.platformType === this.PLATFORM_TYPE['拼多多']) {
                toRouteName = 'pddBaseStepOne'
                queryData.taskId = res.SoHoInfo.TaskId
              } else {
                queryData.wAPPicUrl = encodeURI(this.productInfo.WAPPicUrl)
              }
              // 进入购买第一步
              this.$router.push({
                name: toRouteName,
                query: queryData
              })
            } else {
              // 普通销量模式
              this.SET_CUR_PLATFORM_TYPE(this.platformType)
              let toRouteName = ''
              switch (this.platformType) {
                case this.PLATFORM_TYPE['京东']:
                  toRouteName = 'jdStepOne'
                  break
                case this.PLATFORM_TYPE['拼多多']:
                  toRouteName = 'pddStepOne'
                  break
                case this.PLATFORM_TYPE['抖店']:
                  toRouteName = 'dyStepOne'
                  break
                default:
                  // 淘宝、天猫、淘工厂
                  toRouteName = 'stepOne'
                  break
              }
              this.$router.push({
                name: toRouteName,
                query: {
                  productId: this.productInfo.ProductID,
                  wAPPicUrl: encodeURI(this.productInfo.WAPPicUrl),
                  isFreeCard: this.productInfo.IsFreeCard
                }
              })
            }
          }
        })
        .catch((err) => {
          Indicator.close()
          // 若接收到【停发地区异常标识】时，给出提示弹窗，内容如下：
          if (err.ErrCode === 306) {
            MessageBox({
              title: '提示',
              message: err.ErrMsg,
              showCancelButton: true,
              confirmButtonText: '确定',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') {
                this.IsCfmdLimitArea = true
                this.fetchOpenShouhuoData(this.productID)
              }
            })
            return
          }
          this.handleSubmitErr(err)
        })
    },
    // 处理提交订单返回错误
    handleSubmitErr(res) {
      let modalComponent = this.$refs.modalframe
      if (res.ErrMsg.indexOf('限制类型') > -1) {
        const mainContent = JSON.parse(res.ErrMsg.split(';')[1])
        const LimitType = mainContent['限制类型']
        const MonthRemindCount = Number(mainContent['已兑换数量'])
        const MonthLimitCount = Number(mainContent['单月兑换上限'])
        const RecoveryTime = mainContent['恢复时间']
        const isOver = MonthRemindCount >= MonthLimitCount
        let title = '为了共同富裕，免单商品设置兑换上限'
        if (LIMIT_TYPE['全量订单'] === LimitType) {
          title = '为了共同富裕，平台所有商品设置兑换上限'
          if (isOver) {
            this.warnOfLimitDialogInfo = {
              title,
              exceedLimit: true,
              mainContent: mainContent,
              subTip: `本月无法继续兑换所有免单和付费商品，将于【${RecoveryTime}】恢复。请恢复后再来购买吧`,
              confirmButtonText: '我知道了',
              cancelButtonText: '查看其他商品'
            }
          } else {
            this.warnOfLimitDialogInfo = {
              title,
              exceedLimit: false,
              mainContent: JSON.parse(res.ErrMsg.split(';')[1]),
              subTip: '如达到上限，本月将无法继续兑换所有商品。请合理分配抢购额度。是否继续兑换？',
              confirmButtonText: '继续兑换',
              cancelButtonText: '取消'
            }
          }
        } else {
          if (isOver) {
            let mainContent = JSON.parse(res.ErrMsg.split(';')[1])
            // 如识别到异常为【单月免单订单超额提示】
            this.warnOfLimitDialogInfo = {
              title,
              exceedLimit: true,
              mainContent: mainContent,
              subTip: `本月无法继续兑换，将于${RecoveryTime}恢复。付费商品不受影响，可前往查看。`,
              confirmButtonText: '我知道了',
              cancelButtonText: '查看其他商品'
            }
          } else {
            this.warnOfLimitDialogInfo = {
              title,
              exceedLimit: false,
              mainContent: mainContent,
              subTip: '如达到上限，本月将无法继续兑换。付费商品不受影响，请合理分配抢购额度。是否继续兑换？',
              confirmButtonText: '继续兑换',
              cancelButtonText: '取消'
            }
          }
        }
        this.isShowWarnOfLimitDialog = true
        return
      }
      if (res.ErrMsg === '当前商品已购买过，限购一件。独乐乐不如众乐乐，分享给好友吧' || res.ErrMsg === '当前商品已购买过或被关联的亲朋好友购买过，限购一件。独乐乐不如众乐乐，分享给好友吧~') {
        res.ErrMsg =
          res.ErrMsg === '当前商品已购买过或被关联的亲朋好友购买过，限购一件。独乐乐不如众乐乐，分享给好友吧~' ? '您已购买过或暂不满足当前商品的购买要求，无法进行购买，换件商品看看吧~' : res.ErrMsg
        MessageBox({
          title: '提示',
          message: res.ErrMsg,
          showCancelButton: true,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        })
      } else if (res.ErrMsg === '抱歉哟，名额已被抢光，请选择其他商品') {
        this.isShowModal = true
        this.isNoProduct = true
        modalComponent.openSouhuo()
      } else if (res.ErrMsg === '商品的免单活动结束') {
        this.changeToFreeCard('商品免单活动结束啦，是否继续购买？', false)
      } else if (res.ErrMsg === '商品已经加入免单活动') {
        this.changeToFreeCard('商品已加入免单活动，需要免单卡才能进行兑换，是否继续购买？', true)
      } else if (res.ErrMsg === '免单卡不足') {
        MessageBox({
          title: '提示',
          message: res.ErrMsg,
          showCancelButton: true,
          confirmButtonText: '获取更多',
          cancelButtonText: '留在此页',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            this.$router.replace({
              name: 'collarCartCenter'
            })
          } else {
            this.fetchData()
          }
        })
      } else if (res.ErrMsg === '当前账户已被限制购买，可点击下方按钮查看详情。如有疑问，请联系客服') {
        MessageBox({
          title: '提示',
          message: '当前账户已被限制购买，可点击下方按钮查看详情。如有疑问，请联系客服',
          showCancelButton: true,
          confirmButtonText: '查看详情',
          cancelButtonText: '关闭',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            this.$router.replace({
              name: 'violationPage',
              query: { type: 1 }
            })
          }
        })
      } else if (res.ErrMsg === '亲，需要升级成为V2会员以上才可购买此商品。购买完成2单并且成功邀请1位好友，即可升级为V2会员，快去升级吧~') {
        MessageBox({
          title: '提示',
          message: res.ErrMsg,
          showCancelButton: true,
          confirmButtonText: '我要升级',
          cancelButtonText: '关闭',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            this.$router.push({ name: 'memberUpgrade' })
          }
        })
      } else if (res.ErrMsg === '存在待处理事项未完成，请尽快联系客服处理后，即可恢复正常购买') {
        MessageBox({
          title: '提示',
          message: res.ErrMsg,
          showCancelButton: true,
          confirmButtonText: '查看待处理',
          cancelButtonText: '关闭',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            this.$router.push({
              name: 'violationPage',
              query: { type: 0 }
            })
          }
        })
      } else if (res.ErrMsg === '商品已临时下架，晚点再来看看吧') {
        MessageBox({
          title: '提示',
          message: '商品已开启优质买家（特殊）才允许购买，后续请继续购买其他商品并保持良好的购物行为，即可有机会升级至优质买家',
          showCancelButton: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            this.$router.push({ name: 'souhuo' })
          }
        })
      } else if (res.ErrMsg === '由于存在淘客订单，限制24小时购买相同店铺商品；购物时确保仅使用淘宝APP搜索购买，避免被再次限制') {
        MessageBox({
          title: '提示',
          message: `由于存在淘客订单，24小时内限制购买该店铺商品。<br>有关淘客的具体规则，可点击左侧查看规则进行查看。`,
          showCancelButton: true,
          confirmButtonText: '我知道了',
          cancelButtonClass: 't_blue',
          confirmButtonClass: 'c000',
          cancelButtonText: '查看规则'
        }).then((action) => {
          if (action === 'confirm') {
            this.$router.push({
              name: 'souhuo'
            })
          } else {
            this.$router.push({
              name: 'violationDetail',
              query: {
                type: 0
              }
            })
          }
        })
      } else if (
        /在近\d+天内已购买过同店铺内的商品，暂时无法给到你此优惠，请晚点再来/.test(res.ErrMsg) ||
        /在近\d+天内已购买过关联店铺内的商品，暂时无法给到你此优惠，请晚点再来/.test(res.ErrMsg) ||
        res.ErrMsg === `由于存在淘客订单，限制24小时购买相同商品；购物时确保仅使用${this.PLATFORM_TYPE_DETAIL[this.platformType].collectively}APP搜索购买，避免被再次限制` ||
        res.ErrMsg === `由于存在淘客订单，限制24小时购买相同店铺商品；购物时确保仅使用${this.PLATFORM_TYPE_DETAIL[this.platformType].collectively}APP搜索购买，避免被再次限制`
      ) {
        MessageBox({
          title: '提示',
          message: res.ErrMsg,
          showCancelButton: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        })
      } else {
        if (res.ErrMsg) {
          Toast(res.ErrMsg)
        }
      }
    },
    warnOfLimitDialogConfirm() {
      if (!this.warnOfLimitDialogInfo.exceedLimit) {
        this.isFreeCardLimitRemind = true
        this.fetchOpenShouhuoData(this.productID)
      }
    },
    warnOfLimitDialogCancel() {
      if (this.warnOfLimitDialogInfo.exceedLimit) {
        this.$router.push({ name: 'unSearchCenter' })
      }
    },
    // 订单检查
    checkOrderIsExist(fn) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      CheckIsExistSOrder({ productId: this.productID })
        .then((res) => {
          Indicator.close()
          if (res.IsExists && !res.IsThisProduct) {
            // ------存在订单且不为本商品------
            removeStore('HAVE_UNFINISHED_ORDER')
            MessageBox({
              title: '提示',
              message: '存在一个订单未完成，请完成后再回来吧',
              showCancelButton: true,
              confirmButtonText: '去完成',
              confirmButtonClass: 't_f23030'
            }).then((action) => {
              if (action === 'confirm') {
                this.$router.push({
                  name: 'order',
                  query: {
                    tabIndex: 1,
                    flag: 'dialog'
                  }
                })
              }
            })
          } else if (res.IsExists && res.IsThisProduct) {
            // ------存在订单且为本商品------
            // this.isBaseSaleModel = res.IsBaseSaleModel
            // if (res.IsBaseSaleModel) {
            //   // 是否为基础销量模式，是则跳过订单检查阶段
            //   fn()
            //   return
            // }
            if (res.SOStatus === 4) {
              // 待搜索-进入第一步
              this.SET_CUR_PLATFORM_TYPE(this.platformType)
              let toRouteName = ''
              switch (this.platformType) {
                case this.PLATFORM_TYPE['京东']:
                  // 京东
                  toRouteName = 'jdStepOne'
                  break
                case this.PLATFORM_TYPE['拼多多']:
                  // 拼多多
                  toRouteName = 'pddStepOne'
                  break
                case this.PLATFORM_TYPE['抖店']:
                  toRouteName = 'dyStepOne'
                  break
                default:
                  // 淘宝、天猫、淘工厂
                  toRouteName = 'stepOne'
                  break
              }
              this.$router.push({
                name: toRouteName,
                query: {
                  productId: this.productInfo.ProductID,
                  wAPPicUrl: encodeURI(this.productInfo.WAPPicUrl),
                  isFreeCard: this.productInfo.IsFreeCard
                }
              })
            } else if (res.SOStatus === 0) {
              // 基础销量模式只有待完成状态，无其他状态
              // 待完成-我的订单待完成
              this.$router.push({
                name: 'order',
                query: {
                  tabIndex: 1,
                  flag: 'flag'
                }
              })
            } else {
              this.$router.push({
                name: 'order',
                query: {
                  tabIndex: 0,
                  flag: 'flag'
                }
              })
            }
          } else {
            fn()
          }
        })
        .catch((err) => {
          Toast(err.ErrMsg)
          this.fetchData()
        })
    },
    // 立即搜货
    openSouhuo() {
      if (!this.finishedLoading) return
      if (this.loginState) {
        this.checkOrderIsExist(() => {
          this.fetchOpenShouhuoData(this.productID)
        })
      } else {
        this.unLoginModal()
      }
    },
    // 立即兑换
    handleConvert() {
      if (!this.finishedLoading) return
      let carNumber = this.productInfo.FreeCardNum
      // 新人免单卡数量为1
      if (this.productInfo.IsNewPerson) carNumber = 1
      let messageText = `商品需要 <span class="t_f23030">${carNumber}</span> 张免单卡，是否确认兑换`
      if (this.loginState) {
        this.checkOrderIsExist(() => {
          MessageBox({
            title: '提示',
            message: messageText,
            showCancelButton: true,
            confirmButtonText: '确定',
            confirmButtonClass: 't_f23030'
          }).then((action) => {
            if (action === 'confirm') {
              this.fetchOpenShouhuoData(this.productID)
            }
          })
        })
      } else {
        this.unLoginModal()
      }
    },
    // 加入提醒夹
    openRemind() {
      if (this.loginState) {
        if (this.isSetting) return
        this.isSetting = true
        Indicator.open({
          text: '加入收藏中',
          spinnerType: 'triple-bounce'
        })
        ProductFavoriteAdd({ productId: this.productID })
          .then((res) => {
            Indicator.close()
            this.isSetting = false
            this.isCancelRemid = true
            this.productInfo.IsFavorite = true
            Toast('已加入收藏夹')
          })
          .catch((err) => {
            Indicator.close()
            this.isSetting = false
            Toast(err.ErrMsg)
          })
      } else {
        this.unLoginModal()
      }
    },
    // 移出提醒夹
    cancelRemind() {
      if (this.loginState) {
        if (this.isSetting) return
        this.isSetting = true
        Indicator.open({
          text: '移出中',
          spinnerType: 'triple-bounce'
        })
        IsSetRemind({ productId: this.productID })
          .then((res) => {
            Indicator.close()
            this.isSetting = false
            this.isCancelRemid = false
            this.productInfo.IsFavorite = false
            Toast('已移出收藏夹')
          })
          .catch((err) => {
            Indicator.close()
            this.isSetting = false
            Toast(err.ErrMsg)
          })
      } else {
        this.unLoginModal()
      }
    },
    addToRemindClip() {
      this.isShowModal = false
      this.openRemind()
    },
    // 抢光了，展示抢购是时间弹窗
    showGoodsTime() {
      // 是否展现预约提醒引导下载APP配置 start
      if (this.getIfShowAppDownloadGuide && !this.getIsApp) {
        let title = this.isPrePurchase ? '该功能为APP限定功能' : '前往下载APP'
        let desc = this.isPrePurchase ? '请前往APP继续操作取消预约' : '由于公众号通知权限预约提醒功能在APP才能使用哦~'
        let isLinkToApp = !this.isPrePurchase
        this.SET_GUIDE_TO_APP_POPUP_INFO({
          isShow: true,
          title,
          desc,
          isLinkToApp
        })
        return
      }
      // 是否展现预约提醒引导下载APP配置 start
      let timeList = this.productInfo.ScareBuyNodeList
      if (timeList && timeList.length > 0) {
        if (!this.getIsApp) {
          this.nodeTimeDialogShow = true
        } else {
          if (!this.loginState) {
            this.unLoginModal()
          } else {
            this.currentNodeData = this.productInfo.ScareBuyNodeList
            this.isShowTimeNodeDialogOfApp = true
          }
        }
      } else {
        MessageBox({
          title: '提示',
          message: '亲，该商品今天暂无补货计划，明天再来吧~',
          showCancelButton: false,
          confirmButtonText: '我知道了'
        })
      }
    },
    // 客服
    contactCs() {
      this.$router.push({
        name: 'posterDetail',
        query: {
          isContact: 1
        }
      })
    },
    // 收藏
    collectionBtn() {
      if (this.productInfo.IsFavorite) {
        this.cancelRemind()
      } else {
        this.openRemind()
      }
    },
    async shareClick() {
      if (this.loginState) {
        if (this.getIsApp) {
          if (this.sharePopupData.posterPic) {
            this.sharePopupData.isShow = true
          } else {
            this.GetShareGoodsImage()
          }
        } else {
          this.$router.push({
            name: 'ShareByImg',
            query: {
              type: 'goods',
              productId: this.productInfo.ProductID,
              pageType: 10
            }
          })
        }
      } else {
        this.unLoginModal()
      }
    },
    // 商品页分享图片地址
    GetShareGoodsImage() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        ProductId: this.productID,
        pageType: 10
      }
      GetShareGoodsImage(params)
        .then((res) => {
          this.resHandler(res)
        })
        .catch((e) => {
          Indicator.close()
          Toast(e.ErrMsg)
        })
    },
    // 转码图片分享接口(商品分享接口)
    async RecommendProductFrontEndConvertLink({ tempData = {} }) {
      const { ProductFrontEndConvertLink } = tempData
      const base64 = await this.$utils.convertImageToBase64(ProductFrontEndConvertLink.ProductPic)
      ProductFrontEndConvertLink.ProductPic = base64
      RecommendProductFrontEndConvertLink({
        ...ProductFrontEndConvertLink
      }).then((res) => {
        this.resHandler(res)
      })
    },
    resHandler(res) {
      const { ImgUrls, IsFrontEndConvertLink } = res.Data
      if (IsFrontEndConvertLink) {
        this.RecommendProductFrontEndConvertLink({ tempData: res.Data })
        return
      }
      Indicator.close()
      this.sharePopupData.isShow = true
      // this.sharePopupData.posterPic = ImgUrls.replace(/http:/g, 'https:')
      this.sharePopupData.posterPic = ImgUrls
    },
    onShareTypeSelect(option) {
      option.imageUrl = this.sharePopupData.posterPic
      this.$uni.postMessage({
        data: {
          shareMessage: option
        }
      })
      this.sharePopupData.isShow = false
    },
    // 返回顶部
    returnTop() {
      this.container.scrollTop = 0
    },
    // 滚动监听
    handleScroll(e) {
      // 滚动高度
      let scrollTop = this.container.scrollTop
      // 屏幕高度
      let documentH = document.documentElement.clientHeight || document.body.clientHeight
      if (scrollTop > documentH) {
        this.isReturn = true
      } else {
        this.isReturn = false
      }
      this.isFixed = scrollTop > this.fixedTop
    },
    // 返回上一页
    returnBeforeRoute() {
      let routeNameArray = ['souhuo', 'newProduct', 'onePackage', 'presellGood', 'searchResult', 'order', 'hadRefund', 'invitationEvaluation']
      if (routeNameArray.indexOf(this.beforeRouteName) !== -1) {
        this.$router.go(-1)
      } else {
        this.$router.push({
          name: 'souhuo'
        })
      }
    },
    // 商品已加入免单
    changeToFreeCard(infoMsg, isFreeCard) {
      MessageBox({
        title: '提示',
        message: infoMsg,
        showCancelButton: true,
        confirmButtonText: '留在此页',
        cancelButtonText: '返回',
        confirmButtonClass: 't_f23030'
      })
        .then((action) => {
          if (action === 'confirm') {
            this.$router.replace({
              name: 'goodsDetail',
              query: {
                productID: this.productID,
                isFreeCard: isFreeCard
              }
            })
            this.fetchData()
          } else {
            this.returnBeforeRoute()
          }
        })
        .catch((res) => {})
    }
  },
  filters: {
    toFixed(value) {
      if (!value) value = 0
      return parseFloat(value).toFixed(2)
    },
    toFixedInt(val) {
      if (!val) val = 0
      return parseFloat(val)
        .toFixed(2)
        .split('.')[0]
    },
    toFixedDecimal(value) {
      if (!value) value = 0
      return parseFloat(value)
        .toFixed(2)
        .split('.')[1]
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.beforeRouteName = from.name
    })
  },
  beforeRouteLeave(to, from, next) {
    MessageBox.close()
    next()
  }
}
</script>

<style scoped lang="scss">
.container {
  font-size: 12px;
  padding-bottom: 4em;
}
.detailSwiper {
  padding: 3%;
}
.detailSwiper .mint-swipe {
  width: 25em;
  height: 25em;
  margin: 0 auto;
  position: relative;
  overflow: visible;
  background: #fff;
}
.detailSwiper .mint-swipe .swiperPic {
  width: 25em;
  height: 25em;
}
.fs-13 {
  font-size: 13px;
}
.t_999 {
  color: #999;
}
.detail-tab {
  padding: 3% 4%;
  background: #fff;
}
.detail-tab span {
  margin-right: 2%;
}
.pro-detail {
  margin-top: 3%;
  background: #fff;
}
.p-titel {
  margin: 0 4%;
  padding: 3% 0;
  border-bottom: 1px solid #f2f2f2;
}
.p-titel span {
  margin-right: 14px;
  font-size: 15px;
}
.p-titel .t_999 {
  font-size: 13px;
}
.pro-contain {
  padding: 3% 4%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.pro-contain img {
  width: 100%;
}
// .pro-detail-btn {
//   background: #fff;
//   height: 57px;
//   text-align: center;
//   position: fixed;
//   bottom: 0;
//   width: 100%;
//   z-index: 900;
// }
.pro-nav {
  position: relative;
  text-align: center;
  width: 30%;
  line-height: 20px;
  color: #999;
  vertical-align: -webkit-baseline-middle;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.collection-bnt .pro-nav {
  width: 20%;
}
.collection-bnt .pro-nav:first-child {
  border-right: 1px solid #eee;
}
.active {
  color: #f23030;
}
.pro-nav .iconfont {
  font-size: 1.5em;
}
.pro-nav-txt {
  font-size: 13px;
}
.souhuo-btn {
  background: #f23030;
  color: #fff;
  width: 70%;
  line-height: 57px;
  display: block;
  font-size: 15px;
}
.collection-bnt .souhuo-btn {
  width: 60%;
}
.sellout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60%;
  background: #898989;
  color: #fff;
  font-size: 15px;
}
.detail-allow-right {
  border: 2px solid #c8c8cd;
  border-bottom-width: 0;
  border-left-width: 0;
  content: ' ';
  top: 50%;
  right: 20px;
  position: absolute;
  width: 5px;
  height: 5px;
  -webkit-transform: translateY(-50%) rotate(135deg);
  transform: translateY(-50%) rotate(135deg);
}
.rotate-45 {
  transform: rotate(-45deg);
  transition: 0.4s linear 0s;
}
.detail-tab-top {
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 10px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.detail-tab-top .title-left {
  width: 100%;
}
.detail-tab-top .title-short {
  font-size: 16px;
  width: 100%;
  max-height: 46em;
  overflow: hidden;
  display: block;
}
.detail-tab-top .title-price {
  color: #f23030;
}
.detail-tab-top .title-price div {
  display: inline-block;
}
.detail-tab-top .title-price .t_999 {
  text-decoration: line-through;
}
.detail-tab-top .price-card-through {
  position: relative;
  top: 3px;
}
.price-tag {
  margin-right: 10px;
  background-color: #f23030;
  font-size: 12px;
  color: #fff;
  padding: 3px 6px 3px 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  position: relative;
  top: -1px;
}
.price-char {
  position: relative;
  top: 3px;
  font-size: 12px;
}
.price-discount-int {
  position: relative;
  top: 4px;
  font-size: 28px;
}
.price-discount-decimal {
  position: relative;
  top: 3px;
  font-weight: bold;
  margin-right: 10px;
}
.price-discount-through {
  position: relative;
  top: 3px;
  color: #999;
  font-size: 13px;
  text-decoration: line-through;
}
.detail-tab-top .title-right {
  width: 15%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.detail-tab-top .title-right button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.detail-tab-top .title-right .iconfont {
  font-size: 20px;
}
.detail-tab-bottom {
  color: #999;
  position: relative;
}
.detail-tab-bottom .rebate-tag {
  background: #ffe7bb;
  color: #ff6d2c;
  border: 1px solid #ffd8bf;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 11px !important;
}
.detail-tab-bottom .rebate-span {
  font-size: 13px;
}
.detail-tab-bottom .detail-allow-right {
  top: 15px;
  right: 5px;
}
.detail-tab-slide {
  position: relative;
  height: 32px;
  line-height: 32px;
}
.detail-tab-risk {
  display: flex;
  align-items: center;
  height: 38px;
  font-size: 13px;
}
.detail-tab-risk .rist-tip {
  padding: 4px 5px;
  color: #60c781;
  border: 1px solid #60c781;
  background: #effaf3;
  box-sizing: border-box;
  border-radius: 5px;
  margin-right: 10px;
}
.detail-tab-risk .rist-detail {
  color: #3399ff;
  cursor: pointer;
}
.rist-detail .iconfont {
  font-size: 13px;
}
img[lazy='loading'] {
  width: 100%;
  height: auto;
  background: #f5f5f5;
}
.none-select {
  pointer-events: none;
  user-select: none;
  -webkit-touch-callout: none;
}
/* echar */
.echarts-box {
  margin-top: 3%;
  background: #fff;
}
.echart-title {
  position: relative;
  z-index: 11;
}
.echart-title span {
  color: #3399ff;
  position: absolute;
  right: 3%;
  font-size: 14px;
  top: 16px;
  cursor: pointer;
}
.echarts-box,
#echarts-line {
  width: 100%;
  height: 200px;
  z-index: 10;
}
@media screen and (max-width: 320px) {
  .price-tag,
  .price-discount-decimal {
    margin-right: 5px;
  }
  .echart-title span {
    right: 1%;
  }
}
.warnOfLimitDialogContent {
  padding: 0 20px;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 12px;
    font-size: 18px;
    height: 50px;
  }
  .tip {
  }
  .item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 12px;
    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #1cc21b;
      margin-right: 8px;
      &.normal {
        background-color: #9a9a9a;
      }
      &.alert {
        background-color: #f22c2c;
      }
    }
    .label {
      margin-right: 8px;
    }
  }
}
</style>
